import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { OtpDialogComponent } from './otp-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DirectivesModule } from 'src/app/views/layout/directives/directives.module';

const router: Routes = [
  {
    path: '',
    component: OtpDialogComponent
  }
]

@NgModule({
  declarations: [OtpDialogComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(router),
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    DirectivesModule
  ]
})
export class OtpDialogModule { }
